import { toast } from "@medusajs/ui"

/** POSTs to an export endpoint (audited, read-permission) and saves the CSV the server returns. */
export async function downloadExport(path: string, body: Record<string, unknown> = {}) {
  const base = import.meta.env.VITE_MEDUSA_BACKEND_URL || window.location.origin
  try {
    const res = await fetch(base + path, { method: "POST", credentials: "include", headers: { "content-type": "application/json", accept: "text/csv" }, body: JSON.stringify(body) })
    if (!res.ok) throw new Error((await res.json().catch(() => null))?.message ?? "Export failed")
    const name = /filename="([^"]+)"/.exec(res.headers.get("content-disposition") ?? "")?.[1] ?? "export.csv"
    const url = URL.createObjectURL(await res.blob())
    const a = Object.assign(document.createElement("a"), { href: url, download: name })
    document.body.appendChild(a)
    a.click()
    a.remove()
    setTimeout(() => URL.revokeObjectURL(url), 1000)
    toast.success("Export downloaded")
  } catch (e) {
    toast.error(e instanceof Error ? e.message : "Export failed")
  }
}
